import { ApiRetailerPaymentType, ApiTransaction } from '@vend/types'
import { IPromise, IScope } from 'angular'
import type { VdEscapeStack } from '../../../../vend-ui/types'
import { $q } from '../../../../ng-compat/imports'
import { convertTransactionToApiTransaction } from '../../../../functions/payments'
import { Transaction } from './queries/Transaction'

interface SwiperPaymentModalOptions {
  retailerPaymentType: ApiRetailerPaymentType
  registerId: string
  amount: number
  currency: string
  paymentTypeId: number
}

export class SwiperPaymentModalController {
  public readonly close: (val?: IPromise<ApiTransaction>) => void
  public readonly registerId: string
  public readonly retailerPaymentType: ApiRetailerPaymentType
  public readonly amount: number
  public readonly currency: string
  public readonly closeModal: (transaction?: Transaction) => void
  private readonly internalClose: (val?: IPromise<ApiTransaction>) => void

  constructor(
    $scope: IScope,
    close: (val?: IPromise<ApiTransaction>) => void,
    public readonly options: SwiperPaymentModalOptions,
    private readonly vdEscapeStack: VdEscapeStack
  ) {
    'ngInject'

    this.internalClose = close
    this.closeModal = (transaction?: Transaction) => {
      if (transaction) {
        this.internalClose(
          Promise.resolve(
            convertTransactionToApiTransaction(transaction, options)
          )
        )
        return
      }
      this.internalClose()
    }
    this.close = this.internalClose

    this.registerId = options.registerId
    this.retailerPaymentType = options.retailerPaymentType
    this.amount = options.amount
    this.currency = options.currency

    $scope.$on('$destroy', () =>
      this.vdEscapeStack.deregister(() => this.internalClose($q.reject()))
    )
  }
}
